<template>
  <div id="autokosten" class="bg-color-green p30 car-block">
      <div class="container">
        <div class="row">
          <div class="col-md-9">
            <h4 class="text-color tco-cta--text p-0 mt-15">Bekijk het volledige overzicht van de autokosten met de TCO Vergelijker..</h4>
          </div>
          <div class="col-md-3 text-center">
            <div class="vergelijk p-0 m-0" style="background:none;box-shadow:none;">
              <nuxt-link :to="url" class="specs " @click.native="reportClick()" style="    margin-top: 4px;    margin-bottom: 5px;">Autokosten</nuxt-link>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
  export default {
    props: ['url', 'locname'],
    methods: {
      reportClick() {
        this.$gtag('event', `clicked-on-cta-${this.locname}`, {
        event_category: 'Model Overview',
        event_label: this.$route.params.brand,
        });
      }
    }
  }
</script>
<style lang="scss">
  #autokosten {
    h4 {
      font-size: 14px;
      margin-bottom: 20px;
    }
  }
  .tco-cta--text{
  text-align: center !important;
  @media (min-width: 768px) {
    text-align: left !important;
  }
  }
</style>
